import { render, staticRenderFns } from "./NowPractice.vue?vue&type=template&id=1110515c&scoped=true"
import script from "./NowPractice.vue?vue&type=script&lang=js"
export * from "./NowPractice.vue?vue&type=script&lang=js"
import style0 from "./NowPractice.vue?vue&type=style&index=0&id=1110515c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1110515c",
  null
  
)

export default component.exports